/* ======================================================
   SD Header Hover - rozwija dropdown menu na hover (zamiast click)
   ======================================================
   Dawn standardowo uzywa <details><summary> ktore otwieraja sie po
   kliknieciu w summary. Ten skrypt ustawia details.open=true na hover
   (z 250ms delay na mouseleave zeby user mogl przejechac myszka
   na submenu bez zwiniecia).

   Dziala tylko na desktop z mysza (matchMedia 'hover: hover').
   Na touch device (tablet, mobile) menu zachowuje sie standardowo - tap.

   ROLLBACK: usun ten plik z assets + linie z theme.liquid.
   ====================================================== */
(function () {
  if (window.__sdHeaderHoverBound) return;
  window.__sdHeaderHoverBound = true;

  function isHoverCapable() {
    return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function bind() {
    if (!isHoverCapable()) return;
    var headerMenus = document.querySelectorAll('header-menu');
    headerMenus.forEach(function (hm) {
      if (hm.__sdHoverBound) return;
      hm.__sdHoverBound = true;
      var details = hm.querySelector('details');
      if (!details) return;
      var closeTimer = null;

      hm.addEventListener('mouseenter', function () {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        details.open = true;
      });

      hm.addEventListener('mouseleave', function () {
        // Delay 250ms - user moze przejechac z summary na submenu
        closeTimer = setTimeout(function () {
          details.open = false;
          closeTimer = null;
        }, 250);
      });

      // Focus-within (klawiatura) - pokazuje, focus poza ukrywa
      hm.addEventListener('focusin', function () {
        if (closeTimer) clearTimeout(closeTimer);
        details.open = true;
      });

      hm.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!hm.contains(document.activeElement)) {
            details.open = false;
          }
        }, 0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  // Re-bind po reload sekcji w theme editor
  document.addEventListener('shopify:section:load', bind);
})();
